module.exports = __webpack_public_path__ + "img/image8 (1).1699e2e0.svg";